export default {
    origin: (url) => `https://nekidaem.ru${url}`,
    blog_card: (url, mobile) => {
        let pathArr =  url.split('/')
        let paramsDesk = '?resize_w=-&resize_h=150&crop_h=-&crop_w=-'
        let paramsMob = '?resize_w=724&resize_h=-&crop_h=-&crop_w=-'
        return `https://nekidaem.ru/media/crop-resize/original_images/${pathArr[pathArr.length-1]}${mobile ? paramsMob : paramsDesk}`
    }
}
